export type AdminRoleRow = {
  user_id: string;
  is_super: boolean;
  display_name: string | null;
  workspace_label: string | null;
  email: string | null;
  granted_at: string | null;
};

export type LookupUser = {
  id: string;
  email: string | null;
  display_name: string | null;
  workspace_label: string | null;
  account_tier: string | null;
  roles: string[];
  created_at: string;
};

export type AuditAction =
  | "grant_admin_role"
  | "revoke_admin_role"
  | "grant_super_admin_role"
  | "revoke_super_admin_role";

export const labelFor = (row: { display_name: string | null; workspace_label: string | null; email: string | null }) =>
  row.workspace_label || row.display_name || row.email || "Unknown user";
